
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[id]/articles",
      function () {
        return require("private-next-pages/users/[id]/articles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/[id]/articles"])
      });
    }
  